import React from 'react';
import classNames from 'classnames';

interface IProps {
  withDropdown?: boolean;
  selected?: boolean;
  count?: number;
  mobileOnlyCount?: boolean;
  loading?: boolean;
  dismissible?: boolean;
  children: React.ReactNode;
  onClick?: (e) => void;
}

export default function FilterChip({
  withDropdown = false,
  selected = false,
  count = 0,
  mobileOnlyCount = false,
  loading = false,
  dismissible = false,
  children,
  onClick,
} : IProps) {

  const classes = classNames(
    'filter-chip',
    { 'filter-chip--with-dropdown': withDropdown },
    { 'filter-chip--with-count': count > 1 && !mobileOnlyCount },
    { 'filter-chip--with-mobile-count': count > 0 && mobileOnlyCount },
    { 'filter-chip--selected': selected },
    { 'filter-chip--loading': loading },
    { 'filter-chip--dismissible': dismissible },
  );

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
    >
      {children}
      <span className="filter-chip__count">{count}</span>
      {dismissible &&
        <span className="filter-chip__close" />
      }
    </button>
  );
}
